@use "../../sass/global/global" as *;

/* stylelint-disable max-nesting-depth, selector-max-compound-selectors, scss/at-rule-no-unknown */
// Icon Styles
.ux-iws-teaser-icon {
    background-color: $color-white;
    display: inline-block;
    margin-bottom: 30px;
    vertical-align: top;
    width: calc(50% - 10px);
    cursor: pointer;

    @media only screen and (min-width: $gridle-t-max) {
        width: calc(25% - 5px);
    }

    &__container {
        align-items: center;
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    &__wrapper {
        align-items: center;
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        text-align: center;
    }

    &__icon-container {
        ux-icon {
            font-size: 100px;
        }
    }

    *[slot="title"] {
        margin: 18px 0 0;

        strong {
            font-weight: normal;
        }
    }

    *[slot="link"] {
        margin-top: 15px;
    }

    *[slot="text"] {
        color: $color-gray-text;
    }

    *[slot="text"] > *:last-child {
        margin-bottom: 0;
    }

    *[slot="image"] img {
        display: block;
    }

    .ux-iws-link-wrapper:hover {
        .ux-text-link--green {
            color: $color-black;
        }

        ux-icon[name="arrow-small-right"] {
            transform: translateX(5px);
        }
    }

    &--shadow {
        width: 100%;

        @media only screen and (min-width: $gridle-t-min) {
            width: calc(50% - 35px);
        }

        @media only screen and (min-width: $gridle-t-max) {
            width: calc(25% - 35px);
        }
    }

    &__shadow &__wrapper {
        padding: 20px 20px 25px;
    }

    &--plain,
    &--service-icon,
    &--image {
        width: 100%;

        .ux-iws-teaser-icon__icon-container ux-icon {
            font-size: 65px;
            margin-bottom: 25px;
            margin-top: 15px;
            transform-origin: 50% 100%;
            transition: transform $animationSpeed-normal $animationEasing-ease;
        }

        *[slot="link"] {
            margin-bottom: 5px;
            margin-top: 20px;
        }

        *[slot="title"] {
            @include font(bold);
            margin: 0;
        }
    }

    &--image &__wrapper {
        padding: 25px;
    }

    &--image *[slot="image"] {
        overflow: hidden;

        img {
            transition: transform $animationSpeed-normal $animationEasing-ease;
        }
    }

    &--image:hover *[slot="image"] img {
        transform: scale(1.05);
    }

    &--service-icon &__wrapper {
        padding: 25px 25px 15px;

        @media only screen and (min-width: $gridle-t-min) {
            padding: 25px;
        }
    }

    &--plain &__wrapper {
        padding: 30px 25px 10px;

        @media only screen and (min-width: $gridle-t-min) {
            padding: 30px 25px 25px;
        }
    }

    &--service-icon:hover {
        .ux-iws-teaser-icon__icon-container ux-icon {
            transform: scale(1.1);
        }
    }

    &--icon-box {
        display: inline-flex;

        .ux-iws-teaser-icon__container {
            display: flex;
            flex: 1 0 auto;
            max-width: 100%;
        }

        .ux-iws-teaser-icon__wrapper {
            align-self: stretch;
            flex: 1;
            justify-content: space-between;
        }

        *[slot="link"] {
            margin-top: 15px;
        }

        *[slot="title"]:last-child,
        *[slot="text"] {
            margin-bottom: auto;
        }

        .ux-iws-link-wrapper--with-link *[slot="title"]:nth-last-of-type(2) {
            margin-bottom: auto;
        }

        .ux-iws-link-wrapper {
            padding: 30px 20px;

            @media only screen and (min-width: $desktop-l) {
                padding: 40px 20px 35px;
            }
        }

        &[teaser-color="blue"] {
            background-color: $color-blue-hint;
            color: $color-white;
            fill: $color-white;

            p {
                color: $color-white;
            }

            & {
                a:hover {
                    color: $color-white;
                    fill: $color-white;
                }
            }

            .ux-iws-link-wrapper:hover {
                .ux-text-link--green {
                    color: $color-white;
                }

                .ux-iws-teaser-icon__icon-container ux-icon {
                    color: $color-green;
                }
            }
        }

        .ux-iws-link-wrapper .ux-iws-teaser-icon__icon-container ux-icon {
            transition: all $animationSpeed-fast $animationEasing-ease;
        }

        .ux-iws-link-wrapper:hover {
            .ux-iws-teaser-icon__icon-container ux-icon {
                transform: scale(1.05);
            }
        }
    }

    &.is-disabled {
        opacity: 0.5;
        pointer-events: none;
        position: relative;
    }

    .ux-col &,
    .ux-col-12 & {
        margin-bottom: 0;
    }
}

// Icon Grid Styles
.ux-iws-teaser-icon-grid {
    // Mixin for one 1 column
    @mixin column-1 {
        margin-bottom: 10px;
        width: 100%;
    }

    // Mixin for one 2 columns
    @mixin column-2 {
        > * {
            width: calc(50%);
        }
    }
    // Mixin for query between 2 and 3 columns
    @mixin column-2-to-3 {
        flex-direction: row;
        flex-wrap: wrap;

        > *:nth-child(3n):last-child {
            margin-left: auto;
            margin-right: auto;
        }

        > *:nth-child(5n):last-child {
            margin-left: auto;
            margin-right: auto;
        }
    }

    // Mixin for one 3 columns
    @mixin column-3 {
        flex-direction: row;

        > * {
            width: calc(33.3333%);
        }
    }

    // Mixin for nowrap
    @mixin nowrap {
        flex-wrap: nowrap;
    }

    display: flex !important;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;

    > * {
        @include column-1;
    }

    // Container Queries: default
    @container (min-width: 768px) {
        @include column-2;
    }

    @container (min-width: 768px) and (max-width: 1439px) {
        @include column-2-to-3;
    }

    @container (min-width: 1440px) {
        @include column-3;
    }

    &:not(.ux-iws-teaser-icon-grid--five-elements) {
        @container (min-width: 1440px) {
            @include nowrap;
        }
    }

    // Media Queries: MQ via --mq modifier
    &--mq {
        @media (min-width: 768px) {
            @include column-2;
        }

        @media (min-width: 768px) and (max-width: 1023px) {
            @include column-2-to-3;
        }

        @media (min-width: 1024px) {
            @include column-3;
        }

        &:not(.ux-iws-teaser-icon-grid--five-elements) {
            @media (min-width: 1440px) {
                @include nowrap;
            }
        }
    }
}

.ux-iws-teaser-icon-grid--with-background {
    // Mixin for one 1 column
    @mixin column-1 {
        margin-bottom: 30px;
    }

    // Mixin for one 2 columns
    @mixin column-2 {
        > * {
            width: calc(50% - 15px);
        }
    }

    // Mixin for query between 2 and 3 columns
    @mixin column-2-to-3 {
        > *:not(:nth-child(2n)):not(:last-child) {
            margin-right: 30px;
        }

        > *:nth-child(3n):last-child {
            margin-left: auto;
            margin-right: auto;
        }
    }

    // Mixin for one 3 columns
    @mixin column-3 {
        > * {
            width: calc(33.3333% - 20px);
        }

        > *:not(:last-child) {
            margin-right: 30px;
        }
    }
    margin-bottom: 20px;

    margin-top: 50px;

    > * {
        @include column-1;
    }

    @media (min-width: $desktop-l) {
        margin-bottom: 30px;
        margin-top: 60px;
    }

    // Container Queries: default
    @container (min-width: 768px) {
        @include column-2;
    }

    @container (min-width: 768px) and (max-width: 1439px) {
        @include column-2-to-3;
    }

    @container (min-width: 1440px) {
        @include column-3;
    }

    // Media Queries: MQ via --mq modifier
    &.ux-iws-teaser-icon-grid--mq {
        @media (min-width: 768px) {
            @include column-2;
        }

        @media (min-width: 768px) and (max-width: 1439px) {
            @include column-2-to-3;
        }

        @media (min-width: 1440px) {
            @include column-3;
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors, scss/at-rule-no-unknown */
